var map = {
	"./assets/fonts/Khyay-Regular.ttf": 54250,
	"./assets/fonts/MyanmarSansPro-Regular.ttf": 90181,
	"./assets/icons/BookmarkUpdate.svg": 50492,
	"./assets/icons/FontMinus.svg": 6420,
	"./assets/icons/FontPlus.svg": 65820,
	"./assets/icons/FontRefresh.svg": 18661,
	"./assets/icons/Stop.svg": 49979,
	"./assets/icons/add-circle.svg": 75877,
	"./assets/icons/album.svg": 89432,
	"./assets/icons/arrow-back.svg": 69566,
	"./assets/icons/bookmark.svg": 80359,
	"./assets/icons/camera-off.svg": 44326,
	"./assets/icons/camera-on.svg": 95952,
	"./assets/icons/check-circle.svg": 92670,
	"./assets/icons/check-circle2.svg": 35664,
	"./assets/icons/close.svg": 35837,
	"./assets/icons/copy.svg": 28552,
	"./assets/icons/dark-mode.svg": 28477,
	"./assets/icons/down-arrow.svg": 5743,
	"./assets/icons/down-vote-off.svg": 26908,
	"./assets/icons/down-vote-on.svg": 77862,
	"./assets/icons/edit-icon.svg": 41331,
	"./assets/icons/edit-on.svg": 78027,
	"./assets/icons/edit.svg": 975,
	"./assets/icons/empty-star.svg": 11147,
	"./assets/icons/eye-off.svg": 59210,
	"./assets/icons/eye-on.svg": 21172,
	"./assets/icons/facebook-app-symbol.svg": 16142,
	"./assets/icons/file-plus.svg": 40254,
	"./assets/icons/fill-star.svg": 77645,
	"./assets/icons/filter-icon.svg": 92069,
	"./assets/icons/google.svg": 3486,
	"./assets/icons/guide.svg": 4941,
	"./assets/icons/half-star.svg": 76809,
	"./assets/icons/heart-check.svg": 15770,
	"./assets/icons/heart-uncheck.svg": 1661,
	"./assets/icons/home.svg": 74174,
	"./assets/icons/image-placeholder.svg": 16554,
	"./assets/icons/image-preview-placeholder.png": 46889,
	"./assets/icons/light-mode.svg": 7475,
	"./assets/icons/lyrics-image-off.svg": 44187,
	"./assets/icons/lyrics-image-on.svg": 25695,
	"./assets/icons/noti-alert.svg": 25034,
	"./assets/icons/noti.svg": 74135,
	"./assets/icons/pause.svg": 51947,
	"./assets/icons/play.svg": 10757,
	"./assets/icons/plus-circle-off.svg": 12844,
	"./assets/icons/plus-circle-on.svg": 61654,
	"./assets/icons/private-selected.svg": 97290,
	"./assets/icons/private.svg": 20200,
	"./assets/icons/profile-icon.svg": 8744,
	"./assets/icons/public-selected.svg": 70094,
	"./assets/icons/public.svg": 13628,
	"./assets/icons/record-off.svg": 96452,
	"./assets/icons/record-on.svg": 60686,
	"./assets/icons/report-off.svg": 85217,
	"./assets/icons/report-on.svg": 7277,
	"./assets/icons/search.svg": 64343,
	"./assets/icons/searchIcon.svg": 85176,
	"./assets/icons/setting-off.svg": 71401,
	"./assets/icons/setting-on.svg": 3925,
	"./assets/icons/setting.svg": 99941,
	"./assets/icons/share.svg": 67300,
	"./assets/icons/song.svg": 51800,
	"./assets/icons/star.svg": 40815,
	"./assets/icons/tag.svg": 48197,
	"./assets/icons/tag2.svg": 73261,
	"./assets/icons/tik-tok.svg": 9204,
	"./assets/icons/trashIcon.svg": 82476,
	"./assets/icons/uncheck-circle.svg": 76703,
	"./assets/icons/uncheck-circle2.svg": 64463,
	"./assets/icons/up-vote-off.svg": 39173,
	"./assets/icons/up-vote-on.svg": 11345,
	"./assets/icons/version.svg": 25801,
	"./assets/icons/view-arrow.svg": 31256,
	"./assets/images/camera-guitar-logo.png": 65235,
	"./assets/images/chords/A1.jpg": 96205,
	"./assets/images/chords/Ab1.jpg": 53341,
	"./assets/images/chords/Abm1.jpg": 32680,
	"./assets/images/chords/Am1.jpg": 16568,
	"./assets/images/chords/Asharp1.jpg": 26511,
	"./assets/images/chords/Asharpm1.jpg": 95254,
	"./assets/images/chords/B1.jpg": 18468,
	"./assets/images/chords/Bb1.jpg": 34590,
	"./assets/images/chords/Bbm1.jpg": 31981,
	"./assets/images/chords/Bm1.jpg": 14143,
	"./assets/images/chords/C1.jpg": 92071,
	"./assets/images/chords/Cm1.jpg": 54030,
	"./assets/images/chords/Csharp1.jpg": 45037,
	"./assets/images/chords/Csharpm1.jpg": 89496,
	"./assets/images/chords/D1.jpg": 6014,
	"./assets/images/chords/Db1.jpg": 15336,
	"./assets/images/chords/Dbm1.jpg": 6259,
	"./assets/images/chords/Dm1.jpg": 7533,
	"./assets/images/chords/Dsharp1.jpg": 69802,
	"./assets/images/chords/Dsharpm1.jpg": 42185,
	"./assets/images/chords/E1.jpg": 5497,
	"./assets/images/chords/Eb1.jpg": 77537,
	"./assets/images/chords/Ebm1.jpg": 38204,
	"./assets/images/chords/Em1.jpg": 39092,
	"./assets/images/chords/F1.jpg": 67024,
	"./assets/images/chords/Fm1.jpg": 24763,
	"./assets/images/chords/Fsharp1.jpg": 2352,
	"./assets/images/chords/Fsharpm1.jpg": 45339,
	"./assets/images/chords/G1.jpg": 15763,
	"./assets/images/chords/Gb1.jpg": 27571,
	"./assets/images/chords/Gbm1.jpg": 19050,
	"./assets/images/chords/Gm1.jpg": 78474,
	"./assets/images/chords/Gsharp1.jpg": 71841,
	"./assets/images/chords/Gsharpm1.jpg": 99260,
	"./assets/images/eng.png": 75127,
	"./assets/images/fadeOutBg.png": 8692,
	"./assets/images/fb-logo.png": 14523,
	"./assets/images/google-logo.png": 47360,
	"./assets/images/guest-logo.png": 14139,
	"./assets/images/guitar-qr.jpg": 79693,
	"./assets/images/logo-horizontal.png": 40413,
	"./assets/images/logo-only.png": 68523,
	"./assets/images/logo-vertical.png": 61567,
	"./assets/images/my.png": 8277,
	"./assets/images/tiktok-logo.png": 61445,
	"./assets/images/video-dark-blur.png": 4271,
	"./assets/images/video-light-blur.png": 30223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15353;